import React from 'react'

type SmileIconSvgProps = {
  size?: number
  strokeColor?: string
  strokeWidth?: number
}

// SVG converted from Android vector drawable ic_smile.xml
// ViewBox 0 0 86 86 with circle, smile arc, and eyes
const SmileIconSvg: React.FC<SmileIconSvgProps> = ({ size = 200, strokeColor = '#5de878', strokeWidth = 7 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 86 86"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43,43m-39.5,0a39.5,39.5 0,1 1,79 0a39.5,39.5 0,1 1,-79 0"
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.992,52.28s4.027,5.37 10.739,5.37S53.47,52.28 53.47,52.28"
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.999,30.994L31.026,30.994"
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.569,30.994L54.596,30.994"
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SmileIconSvg